import { pickLang } from '@/lib/localizedText'
import type { ContentLang } from '../editorSlice'

type EnKey<K extends string> = `${K}En`

export function getLocalizedField<K extends string, O extends Record<K | EnKey<K>, string | null>>(
  obj: O,
  base: K,
  lang: ContentLang,
): string | null {
  return lang === 'ru' ? obj[base] : obj[`${base}En` as EnKey<K>]
}

export function setLocalizedField<K extends string, V extends string | null>(
  base: K,
  lang: ContentLang,
  value: V,
): Partial<Record<K | EnKey<K>, V>> {
  const key = (lang === 'ru' ? base : `${base}En`) as K | EnKey<K>
  return { [key]: value } as Partial<Record<K | EnKey<K>, V>>
}

/** Значение для ОТОБРАЖЕНИЯ: в правке — только лист текущего языка (пусто
 *  остаётся пустым), в read-only — симметричный фолбэк на другой язык
 *  (у английского курса базовые поля `null`, фолбэка на сервере нет). */
export function getLocalizedDisplay<
  K extends string,
  O extends Record<K | EnKey<K>, string | null>,
>(obj: O, base: K, lang: ContentLang, editable: boolean): string {
  const own = getLocalizedField(obj, base, lang)
  if (editable) return own ?? ''
  const other = lang === 'ru' ? obj[`${base}En` as EnKey<K>] : obj[base]
  return pickLang(own, other)
}
